import React from 'react';
import { Card, Checkbox, ModalFooter, PillButton, Row, Stack, Text } from 'library/ui';

export default function LocationListLayout({
    businessName,
    allLabel,
    allChecked,
    onToggleAll,
    businessExtra,
    children,
    onCancel,
    onSubmit,
    submitting,
}: {
    businessName: string;
    allLabel: string;
    allChecked: boolean;
    onToggleAll: (checked: boolean) => void;
    businessExtra?: React.ReactNode;
    children: React.ReactNode;
    onCancel: () => void;
    onSubmit: () => void;
    submitting: boolean;
}) {
    return (
        <Stack gap="md">
            <Card tone="muted" padding="md">
                <Stack gap="sm">
                    <Stack gap="sm">
                        <Row justify="between" align="center" gap="sm">
                            <Text weight="semibold">{businessName}</Text>
                            <Checkbox label={allLabel} checked={allChecked} onChange={onToggleAll} />
                        </Row>
                        {businessExtra}
                    </Stack>
                    <Text weight="semibold">Locations:</Text>
                    <Stack gap="sm">{children}</Stack>
                </Stack>
            </Card>
            <ModalFooter>
                <PillButton variant="secondary" onClick={onCancel}>
                    Cancel
                </PillButton>
                <PillButton variant="primary" onClick={onSubmit} disabled={submitting}>
                    Set
                </PillButton>
            </ModalFooter>
        </Stack>
    );
}
